import { OrganizationException } from '@/domain/organization/exception/OrganizationException'

export class ForbiddenException extends OrganizationException {
}
